import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationLandLordsPaidDto extends EpimsBaseEntityDto {

   OwnerId: string;
   LandId: string;
   LandName: string;
   ObligationTrackId: string;
   SerialNo: number;
   SubscriptionUserId: string;

}
